import { Stack, TextField, Alert, Typography, FormControlLabel, Checkbox } from "@mui/material"
import { LoadingButton } from "@mui/lab"
import Canvas from "./Canvas"
import { useState } from "react"

export default function Sign({data, onChange, onSubmit, loading, error}){

    const [checked, setChecked] = useState(false)

    return <form onSubmit={onSubmit}>
        
        <Stack spacing={3} sx={{maxWidth: 500, margin: 'auto'}}>

            <Typography>Veuillez entrer le nom qui apparaîtra dans votre signature :</Typography>


            {error && 
                <Alert severity='error'>
                    Une erreur s'est produite. Veuillez réessayer.
                </Alert>
            }


            <TextField
                label="Nom et prénom du signataire"
                value={data.name || ''}
                onChange={e => onChange({...data, name: e.target.value})}
                size='small'
                required
            />

            {data.canvas &&
                <Canvas 
                    onChange={file => onChange({...data, file})} 
                />
            }

            <FormControlLabel 
                required 
                control={
                    <Checkbox 
                        checked={checked}
                        onClick={() => setChecked(!checked)}
                    />
                } 
                label={
                    <Typography variant="body2" color="text.secondary">
                        En cochant cette case, je confirme avoir lu et accepté le document, et je reconnais que ma sélection agit comme ma signature électronique.
                    </Typography>
                }
            />

            <LoadingButton
                type='submit' 
                variant='contained'
                loading={loading}
                disabled={!data.name || (data.canvas && !data.file) || !checked}
            >
                Valider
            </LoadingButton>


        </Stack>

    </form>
}